import { Dispatch, SetStateAction } from "react";

import { IImage } from "@app/types/image";
import { getImageUrl } from "@app/helpers/getUploadUrl";

import { ImageWrapper, Image, StyledDeleteIcon, SvgWrapper } from './styled'
import { EditProductSate } from "@pages/EditProduct/types";

interface RenderImagesByBackendDataProps {
  file: IImage;
  imagesLength: number;
  setState: Dispatch<SetStateAction<EditProductSate>>;
}

const RenderImagesByBackendData = ({
  file,
  imagesLength,
  setState
}: RenderImagesByBackendDataProps) => {
  return (
    <ImageWrapper>
      {
        imagesLength > 1 && (
        <SvgWrapper
          onClick={() => {
            setState((prev) => ({ ...prev, isDeleteModalOpen: true, firebaseImageForProcess: file }))
          }}
        >
          <StyledDeleteIcon />
        </SvgWrapper>
        )
      }
      <Image
        src={getImageUrl(file.url)}
        alt="product"
        onClick={() => {
          setState((prev) => ({ ...prev, isViewImageModalOpen: true, firebaseImageForProcess: file }))
        }}
      />
    </ImageWrapper>
  )
}

export default RenderImagesByBackendData;
